import { useEffect, useRef, useState } from 'react';

// Hook pour détecter quand un élément entre dans le viewport
export const useScrollAnimation = (threshold = 0.1) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  return [ref, isVisible];
};

// Composant wrapper pour les animations
export const AnimateOnScroll = ({ 
  children, 
  animation = 'fadeUp', 
  delay = 0,
  className = '' 
}) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  const animations = {
    fadeUp: 'translate-y-10 opacity-0',
    fadeDown: '-translate-y-10 opacity-0',
    fadeLeft: 'translate-x-10 opacity-0',
    fadeRight: '-translate-x-10 opacity-0',
    fadeIn: 'opacity-0',
    scale: 'scale-95 opacity-0',
    none: ''
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className} ${
        isVisible ? 'translate-y-0 translate-x-0 opacity-100 scale-100' : animations[animation]
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default useScrollAnimation;
